import { Controller } from 'stimulus';

// A Columns menu: checkboxes that show or hide a table's optional columns
// (cells marked data-col="name"), remembered in this browser under
// data-columns-menu-key. Hidden by default; a cleared or blocked
// localStorage just shows the defaults.
//
//   <div data-controller="columns-menu" data-columns-menu-key="equipment-columns">
//     <input type="checkbox" value="manufacturer" data-target="columns-menu.checkbox" data-action="columns-menu#change">
//     <table data-target="columns-menu.table">...<td data-col="manufacturer">
export default class extends Controller {
  static targets = ['checkbox', 'table'];

  connect() {
    const shown = this.load();
    this.checkboxTargets.forEach((box) => { box.checked = shown.includes(box.value); });
    this.apply();
  }

  change() {
    this.apply();
    this.save(this.checkboxTargets.filter((box) => box.checked).map((box) => box.value));
  }

  apply() {
    if (!this.hasTableTarget) return;

    this.checkboxTargets.forEach((box) => {
      this.tableTarget.querySelectorAll(`[data-col="${box.value}"]`).forEach((cell) => {
        cell.style.display = box.checked ? '' : 'none';
      });
    });
  }

  load() {
    try {
      const stored = JSON.parse(window.localStorage.getItem(this.data.get('key')) || '[]');
      return Array.isArray(stored) ? stored : [];
    } catch (e) {
      return [];
    }
  }

  save(shown) {
    try {
      window.localStorage.setItem(this.data.get('key'), JSON.stringify(shown));
    } catch (e) {
      // Private window or blocked storage: the choice lasts for this page only.
    }
  }
}
